import { Menu, MenuItem } from '@mui/material';
import React from 'react';
/**
 * Displays a contextual dropdown menu for a specific table row.
 * The menu is anchored to a provided element and renders a list of menu items specific to the row.
 *
 * @template T - The shape of the data row.
 * @param {object} root0 - Component props.
 * @param {HTMLElement | null} root0.el - The DOM element to which the menu is anchored.
 * @param {T} root0.row - The data object representing the current row.
 * @param {Array<{ label: string; onClick: (row: T) => void }>} root0.rowMenuItems - List of menu actions applicable to the row.
 * @param {() => void} root0.onClose - Callback invoked when the menu is closed.
 * @returns {React.ReactElement | null} A React element rendering the menu, or null if no anchor or row is provided.
 */
export function RowMenu({ el, row, rowMenuItems, onClose }) {
    if (el && row) {
        return (React.createElement(Menu, { anchorEl: el, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, transformOrigin: { horizontal: 'right', vertical: 'top' }, open: true, onClose: onClose }, rowMenuItems.map((rowMenuItem) => (React.createElement(MenuItem, { key: rowMenuItem.label, onClick: () => {
                onClose();
                rowMenuItem.onClick(row);
            } }, rowMenuItem.label)))));
    }
    else {
        return null;
    }
}
